import { toast } from 'react-toastify';
import axios from 'axios';
import * as Yup from 'yup';
import showAlert from '../../../common/utils/alert';
import { getCookie } from '../../../common/utils/api_utils';

export const createRedirectUrl = () => {
  let domainName = window.location.hostname;
  let redirectUrl = `https://${domainName}/`;
  const environment = process.env.REACT_APP_ENVIRONMENT;
  if (environment === 'DEV') {
    redirectUrl = `http://${domainName}:9075/`;
  } else if (environment === 'STAGING') {
    domainName = domainName.replace('builder.webkonnect.xyz', 'builderc.webkonnect.xyz');
    redirectUrl = `https://${domainName}/`;
  } else {
    domainName = domainName.replace('builder.mydrapcode.com', 'builderc.mydrapcode.com');
    redirectUrl = `https://${domainName}/`;
  }
  return redirectUrl;
};

export const tokenSchema = Yup.object({
  token: Yup.string().required('Token is required'),
});

export const linkSchema = Yup.object({
  figmaLink: Yup.string().url('Invalid URL').required('Figma link is required'),
});

export const handleSelectImage = (imageData, setSelectedImages) => {
  setSelectedImages((prevSelected) =>
    prevSelected.some((img) => img.id === imageData.id)
      ? prevSelected.filter((img) => img.id !== imageData.id)
      : [...prevSelected, imageData],
  );
};

export const handleSubmitSelection = async (
  selectedImages,
  selectedModel,
  projectId,
  version,
  figmaLink,
  setSelectedImages,
  generateFigmaToHtml,
) => {
  setSelectedImages([]);
  try {
    let config = {
      headers: {
        Authorization: `Bearer ${getCookie('token')}`,
      },
    };
    const orgEngineUrl = process.env.REACT_APP_ORGANIZATION_ENGINE;
    const clientDetailUrl = `${orgEngineUrl}clients/details/${projectId}/project`;
    const response = await axios.get(clientDetailUrl, config);
    let { user } = response.data;
    const { username, displayName } = user;
    const args = {
      figmaImageUrl: selectedImages,
      aiModel: selectedModel.modelType,
      apiKey: selectedModel.setting.secretKey,
      projectId: projectId,
      projectVersion: version,
      figmaLink: figmaLink,
      userEmail: username,
      userName: displayName,
      token: getCookie('token'),
      userIp: getCookie('userIp'),
    };
    const responseImageCode = await generateFigmaToHtml(args);
    if (responseImageCode.status === 202) {
      toast.success(responseImageCode.data.message);
    }
  } catch (error) {
    if (error.response) {
      const message =
        (error.response && error.response.data && error.response.data.message) ||
        'Something went wrong';
      toast.error(message);
    } else {
      toast.error('An unexpected error occurred.');
    }
  }
};

export const formatModelType = (modelType) => {
  if (modelType == 'OPEN_AI') {
    return 'Open AI';
  } else if (modelType == 'CLAUDE_AI') {
    return 'Anthropic AI';
  } else {
    return 'DeepSeek AI';
  }
};

export const openModal = (imageData, setCurrentImage, setShowModal) => {
  setCurrentImage(imageData);
  setShowModal(true);
};

export const closeModal = (setShowModal, setCurrentImage) => {
  setShowModal(false);
  setCurrentImage(null);
};

export const handleLinkSubmit = async ({
  values,
  setLoading,
  setFigmaLink,
  setFigmaImageData,
  projectId,
  version,
  setIsExpired,
  clearSessionStorage,
  fetchFigmaImage,
}) => {
  try {
    setLoading(true);
    const { figmaLink } = values;
    setFigmaLink(figmaLink);
    sessionStorage.setItem('figmaLink', figmaLink);
    sessionStorage.removeItem('figmaImageData');
    setFigmaImageData([]);
    const response = await fetchFigmaImage({ projectId, figmaLink, version });
    sessionStorage.setItem('figmaImageData', JSON.stringify(response.data));
    setFigmaImageData(response.data);
  } catch (error) {
    if (error.status === 403) {
      toast.error(error.response.data.message);
      clearSessionStorage(setFigmaLink);
      setIsExpired(true);
    } else if (error.status === 404) {
      toast.error(error.response.data.message);
    } else if (error.status === 400) {
      toast.error(error.response.data.message);
    } else {
      toast.error('Please Try Again');
    }
  } finally {
    setLoading(false);
  }
};

export const checkTokenStatus = async (
  setIsExpired,
  setFigmaImageData,
  clearSessionStorage,
  setFigmaLink,
  fetchFigmaData,
  projectId,
  version,
) => {
  try {
    const response = await fetchFigmaData({ projectId, version });
    const { data } = response;
    setIsExpired(data.isExpired);
    const storedImages = sessionStorage.getItem('figmaImageData');
    if (storedImages) {
      setFigmaImageData(JSON.parse(storedImages));
    }
  } catch (error) {
    clearSessionStorage(setFigmaLink);
    console.error('Error fetching Figma data:', error);
  }
};
export const fetchData = async (projectId, version, figmaLink, setData, fetchFigmaToHtmlData) => {
  try {
    const args = {
      projectId: projectId,
      version: version,
      figmaLink: figmaLink,
    };
    const res = await fetchFigmaToHtmlData(args);
    setData(res.data);
  } catch (err) {
    setData('');
  }
};

export const handleTokenSubmit = async ({
  values,
  setLoading,
  setIsExpired,
  setFigmaLink,
  fetchFigmatoken,
  clearSessionStorage,
  projectId,
  version,
}) => {
  const { token } = values;
  setLoading(true);
  try {
    const saveTokenResponse = await fetchFigmatoken({ projectId, version, token });
    const { data } = saveTokenResponse;

    if (!data.isExpired) {
      setIsExpired(false);
      sessionStorage.removeItem('figmaLink');
      sessionStorage.removeItem('figmaImageData');
    } else {
      setIsExpired(true);
      sessionStorage.removeItem('figmaLink');
      sessionStorage.removeItem('figmaImageData');
    }
  } catch (error) {
    if (error.status === 403) {
      toast.error(error.response.data.message);
    }
    setIsExpired(true);
    clearSessionStorage(setFigmaLink);
  } finally {
    setLoading(false);
  }
};

export const deleteFigmaTokenData = async (projectId, version, deleteFigmaTokenDetails) => {
  try {
    const args = {
      projectId: projectId,
      version: version,
    };
    const res = await deleteFigmaTokenDetails(args);
  } catch (error) {
    console.error('error in delete figma ', error);
  }
};

export const handelDeleteFigmaHtml = async (
  figmaLink,
  id,
  projectId,
  version,
  setData,
  deleteFigmaToHtmlData,
) => {
  try {
    const args = {
      figmaLink: figmaLink,
      id: id,
      projectId: projectId,
      version: version,
    };
    const res = await deleteFigmaToHtmlData(args);
    setData(res.data);
  } catch (error) {
    console.error('error', error.message);
  }
};

export const handelDelete = async (
  figmaLink,
  id,
  projectId,
  version,
  setData,
  preConfirm,
  deleteFigmaToHtmlData,
) => {
  showAlert(
    'Are you sure want to delete ?',
    () => {
      preConfirm(figmaLink, id, projectId, version, setData, deleteFigmaToHtmlData);
    },
    'Yes, Delete',
  );
};
